// Imports
var ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.performance-group-style {
  box-shadow: 0 2px 0 0 transparent, 0 2px 5px 0 rgba(0, 0, 0, 0.22);
  margin-top: 1em;
  margin-bottom: 0.5em;
}

.performance-grid {
  display: grid;
  gap: 0.5em;
  grid-template-columns: repeat(2, 1fr);
}
@media (max-width: 1024px) {
  .performance-grid {
    grid-template-columns: 1fr;
  }
}
.performance-grid .performance-item:nth-child(4n+1),
.performance-grid .performance-item:nth-child(4n+2) {
  background-color: #ffffff;
}
.performance-grid .performance-item:nth-child(4n+3),
.performance-grid .performance-item:nth-child(4n+4) {
  background-color: #f3f4f6;
}
@media (max-width: 1024px) {
  .performance-grid .performance-item:nth-child(even) {
    background-color: #f3f4f6;
  }
  .performance-grid .performance-item:nth-child(odd) {
    background-color: #ffffff;
  }
}`, ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
